import { Component } from "@angular/core";
import { buildYard, YARD_BLOCK_HEIGHT } from "./auth-yard";

/**
 * Frame of the signed-out pages (sign in, forgot / reset password): the Smart TOS story on the left — brand,
 * purpose and a top-down yard plan — and the tenant's logo above the projected page content on the right.
 */
@Component({
  selector: "app-auth-shell",
  standalone: true,
  templateUrl: "./auth-shell.component.html",
  styleUrl: "./auth-shell.component.scss"
})
export class AuthShellComponent {
  // ─── Static content (readonly) ────────────────────────────────────────────
  readonly yard = buildYard();
  readonly blockHeight = YARD_BLOCK_HEIGHT;
  readonly journey = ["Gate in", "Yard", "Tally", "Customs", "Billing", "Gate out"];
  readonly year = new Date().getFullYear();
}
